

import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Box, Typography, useMediaQuery } from "@mui/material";

const images = [
  { src: "/image/home.png", text: "Tech Informatic Solutions is a global leader in IT services and pioneered the pace-setting 4th generation IT services model" },
  { src: "/image/home5.jpg", text: "Tech Informatic Solutions is a leading provider of strategic staffing and managed services for the Information Technology and Communications (IT&C) community" },
  { src: "/image/home2.jpg", text: "Tech Informatic Solutions helps you move on with the emerging opportunities in the market and focuses on growth" },
  { src: "/image/home6.jpg", text: "Our objective is to work closely with our clients to create a unique IT experience" },
  { src: "/image/home4.png", text: "We provide stability and strength to your business, allowing you to focus on your core competencies" },
];

const Slideshow = () => {
  const [index, setIndex] = useState(0);
  const [showSlideshow, setShowSlideshow] = useState(false);
  const isMobile = useMediaQuery("(max-width: 768px)"); // Detect mobile view

  useEffect(() => {
    const startSlideshow = setTimeout(() => {
      setShowSlideshow(true);
    }, 2000);

    const interval = setInterval(() => {
      if (showSlideshow) {
        setIndex((prevIndex) => (prevIndex + 1) % images.length);
      }
    }, 2000);

    return () => {
      clearTimeout(startSlideshow);
      clearInterval(interval);
    };
  }, [showSlideshow]);

  return (
    <Box sx={{ position: "relative", width: "100vw", height: "100vh", overflow: "hidden" }}>
      {!showSlideshow ? (
        <Box sx={{ width: "100vw", height: "100vh" }}>
          <img
            src={images[0].src}
            alt="First Slide"
            style={{ width: "100vw", height: "100vh", objectFit: "cover" }}
          />
          {/* Static text placement */}
          <Box
            sx={{
              position: "absolute",
              top: isMobile ? "35%" : "50%", // Higher for mobile
              left: "5%",
              transform: "translateY(-50%)",
              width: isMobile ? "80%" : "40%", // Ensures proper width
              padding: "10px 20px",
              borderRadius: "10px",
              textAlign: "left",
              color: "white",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                fontSize: isMobile ? "1.4rem" : "2rem", // Adjusts size for mobile
                lineHeight: 1.5, 
              }}
            >
              {images[index].text}
            </Typography>
          </Box>
        </Box>
      ) : (
        <Box sx={{ position: "relative", width: "100vw", height: "100vh" }}>
          {/* Image transitions */}
          <motion.img
            key={index}
            src={images[index].src}
            alt={`Slide ${index + 1}`}
            initial={{ x: "0%" }}
            animate={{ x: "-100%" }}
            transition={{ duration: 0.8, ease: "easeInOut" }}
            style={{
              position: "absolute",
              width: "100vw",
              height: "100vh",
              objectFit: "cover",
            }}
          />
          <motion.img
            key={index + 1}
            src={images[(index + 1) % images.length].src}
            alt={`Slide ${index + 2}`}
            initial={{ x: "100%" }}
            animate={{ x: "0%" }}
            transition={{ duration: 0.8, ease: "easeInOut" }}
            style={{
              position: "absolute",
              width: "100vw",
              height: "100vh",
              objectFit: "cover",
            }}
          />
          
          {/* Animated Text */}
          <motion.div
            key={`text-${index}`}
            initial={{ y: "-100%", opacity: 0 }} // Start from top
            animate={{ y: "0%", opacity: 1 }} // Move down into position
            exit={{ y: "100%", opacity: 0 }} // Move further down when exiting
            transition={{ duration: 0.8, ease: "easeInOut", delay: 0.3 }}
            style={{
              position: "absolute",
              top: isMobile ? "35%" : "45%", // Keeps text higher for mobile
              left: "5%",
              transform: "translateY(-50%)",
              width: isMobile ? "80%" : "40%", // Adjusts width for mobile
              padding: "10px 20px",
              borderRadius: "10px",
              textAlign: "left",
              color: "white",
            }}
          >
            <Typography 
              variant="h5" 
              sx={{ 
                fontWeight: "bold",
                fontSize: isMobile ? "1.5rem" : "2rem", // Scales properly
                lineHeight: 1.6 
              }}
            >
              {images[index].text}
            </Typography>
          </motion.div>
        </Box>
      )}
    </Box>
  );
};

export default Slideshow;